import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import HamburgerMenu from './components/HamburgerMenu';
import HomePage from './pages/HomePage';
import LoanPurposePage from './pages/LoanPurposePage';
import PersonalDetailsPage from './pages/PersonalDetailsPage';
import FinancialDetailsPage from './pages/FinancialDetailsPage';
import DeviceDetailsPage from './pages/DeviceDetailsPage';
import IdentificationPage from './pages/IdentificationPage';
import ProcessingPage from './pages/ProcessingPage';
import SuccessPage from './pages/SuccessPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import RateAppPage from './pages/RateAppPage';
import './App.css';

// ScrollToTop component to handle scroll restoration
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' for immediate scroll, or 'smooth' for smooth scrolling
    });
  }, [pathname]);

  return null;
}

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [applicationData, setApplicationData] = useState({
    loanType: '',
    loanAmount: '',
    purpose: '',
    personalDetails: {},
    financialDetails: {},
    deviceDetails: {},
    identification: {}
  });

  const updateApplicationData = (section, data) => {
    setApplicationData(prev => ({
      ...prev,
      [section]: data
    }));
  };

  return (
    <Router>
      <div className="App">
        <Header onMenuClick={() => setIsMenuOpen(true)} />
        <HamburgerMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
        
        {/* ScrollToTop component to handle scroll restoration */}
        <ScrollToTop />
        
        <div className="content">
          <Routes>
            <Route path="/" element={<HomePage data={applicationData} updateData={updateApplicationData} />} />
            <Route path="/loan-purpose" element={<LoanPurposePage data={applicationData} updateData={updateApplicationData} />} />
            <Route path="/personal-details" element={<PersonalDetailsPage data={applicationData} updateData={updateApplicationData} />} />
            <Route path="/financial-details" element={<FinancialDetailsPage data={applicationData} updateData={updateApplicationData} />} />
            <Route path="/device-details" element={<DeviceDetailsPage data={applicationData} updateData={updateApplicationData} />} />
            <Route path="/identification" element={<IdentificationPage data={applicationData} updateData={updateApplicationData} />} />
            <Route path="/processing" element={<ProcessingPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/rate-app" element={<RateAppPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;